import { render, staticRenderFns } from "./QuotationInfo.vue?vue&type=template&id=9f6c788e&"
import script from "./QuotationInfo.vue?vue&type=script&lang=js&"
export * from "./QuotationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports